import React, { createContext, useState } from "react";
// import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";

export const Context = createContext({});
export const ContextProvider = ({ children }) => {
  const [roomId, setRoomId] = useState("");
  const [displayNameUser, setDisplayNameUser] = useState("Customer");

  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [isAdmin, setIsAdmin] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowDream, setIsShowDream] = useState(true);
  const [comments, setComments] = useState([]);
  const [data, setData] = useState([]);
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [user, setUser] = useState(null);
  const [items, setItems] = React.useState([]);
  const [orders, setOrders] = React.useState([]);
  const [expoTokenAdmin, setExpoTokenAdmin] = useState([]);
  const [newList, setNewList] = React.useState([]);
  const [token, setToken] = React.useState(null);
  const [isActive, setIsActive] = React.useState(false);
  const [values, setValues] = React.useState({
    country: "",
    email:"",
    // jwt_decode(localStorage.getItem("Token")).user === undefined
    //     ? ""
    //     : jwt_decode(localStorage.getItem("Token")).user.email,
    displayName:"",
      // jwt_decode(localStorage.getItem("Token")).displayName === undefined
      //   ? ""
      //   : jwt_decode(localStorage.getItem("Token")).user.displayName,
    phone:"",
      // jwt_decode(localStorage.getItem("Token")).phone === undefined
      //   ? ""
      //   : jwt_decode(localStorage.getItem("Token")).user.phone,
    city:"",
      // jwt_decode(localStorage.getItem("Token")).city === undefined
      //   ? ""
      //   : jwt_decode(localStorage.getItem("Token")).user.city,
    address:"",
      // jwt_decode(localStorage.getItem("Token")).address === undefined
      //   ? ""
      //   : jwt_decode(localStorage.getItem("Token")).user.address,
    neighborhood:"",
      // jwt_decode(localStorage.getItem("Token")).neighborhood === undefined
      //   ? ""
      //   : jwt_decode(localStorage.getItem("Token")).user.neighborhood,
    kindPaymentField: "",
  });

  // let navigate = useNavigate();

  const allCategories = [
    "all",
    "جديدنا",
    "الأكثر مبيعا",
    "عروض بسعر اقل من 99 ريال",
    "عطور نيش فاخرة",
    "عطور الشعر والجسم",
    "عروض مميزة",
    "عطور نسائية",
    "عطور رجالية",
    "عطور للجنسين",
  ];
  const [categories, setCategories] = useState(allCategories);

  const addOrder = (name, code, unit, qty, _id, serialNumber) => {
    console.log("orders: ", _id);

    let lengthItem = items?.filter((order) => order._id === _id);
    // console.log("jjj:", lengthItem);
    // console.log("jjj:", lengthItem.length);
    // const newItems = [...orders];
    // console.log("item: ", newItems);
    // newItems[0].qty += lengthItem.length;
    // const newOrder = lengthItem.map((order) => ({
    //   code: order.code,
    //   id: order.id,
    //   name: order.name,
    //   qty: lengthItem.length,
    //   serialNumber: order.serialNumber,
    //   unit: order.unit,
    // }));
    console.log("new: ", items.length);
    // setOrders((prevState) => [...prevState, newOrder[0]]);
    setOrders((prevState) =>
      prevState.map((order) => ({
        category: order.category,
        code: order.code,
        _id: order._id,
        name: order.name,
        qty: lengthItem[0]._id === order._id ? order.qty + 1 : order.qty,
        serialNumber: order.serialNumber,
        unit: order.unit,
        stock: order.stock,
        image: order.image,
        imageLocaly: order.imageLocaly,
        __v: order.__v,
        company_id: order.company_id,
        updatedAt: order.updatedAt,
        created_at: order.created_at,
        basicPrice: order.basicPrice,
        description: order.description,
        marker: order.marker,
        after_vat: order.after_vat,
      }))
    );

    console.log("log jjjjjj: ", orders);
    // setOrders(t);
    // filterOrder();

    // setOrders((c) => [...c, { name, qty, unit, code, serialNumber, id }]);
    // setOrders((c) => [...c, { name, qty, unit, code, serialNumber, id }]);
  };

  const amountOfItemsInCart = (cart) => console.log("kdfs");
  //  cart.reduce((acc, item) => (acc += item), 0);

  const [cartItmes, setCartItems] = React.useState([]);

  const handleAddProduct = (product) => {
    console.log("product: ", product);
    console.log("cart: ", cartItmes);
    const ProductExist = cartItmes.find((item) => item._id === product._id);
    // console.log("ProductExist ...: ", ProductExist);
    if (ProductExist) {
      setCartItems(
        cartItmes.map((item) =>
          item._id === product._id
            ? { ...ProductExist, qty: ProductExist.qty + 1 }
            : item
        )
      );
      localStorage.setItem(
        "Order",
        JSON.stringify(
          cartItmes.map((item) =>
            item._id === product._id
              ? { ...ProductExist, qty: ProductExist.qty + 1 }
              : item
          )
        )
      );
    } else {
      setCartItems([...cartItmes, { ...product, qty: 1 }]);
      localStorage.setItem(
        "Order",
        JSON.stringify([...cartItmes, { ...product, qty: 1 }])
      );
    }

    // console.log("jfjafkjasl: ",[...cartItmes, { ...product, qty: 1 }]);
  };

  const handleRemoveProduct = (product) => {
    const ProductExist = cartItmes.find((item) => item._id === product._id);

    if (ProductExist.qty === 1) {
      setCartItems(cartItmes.filter((item) => item._id !== product._id));
      localStorage.setItem(
        "Order",
        JSON.stringify(cartItmes.filter((item) => item._id !== product._id))
      );
    } else {
      setCartItems(
        cartItmes.map((item) =>
          item._id === product._id
            ? { ...ProductExist, qty: ProductExist.qty - 1 }
            : item
        )
      );
      localStorage.setItem(
        "Order",
        JSON.stringify(
          cartItmes.map((item) =>
            item._id === product._id
              ? { ...ProductExist, qty: ProductExist.qty - 1 }
              : item
          )
        )
      );
    }
    console.log("remove");
  };

  const totalPrice = cartItmes.reduce(
    (price, item) => price + item.qty * item.unit,
    0
  );
  const numberInCart = cartItmes.reduce((number, item) => number * item, 0);

  const value = {
    addOrder,
    setOrders,
    items,
    setItems,
    orders,
    isAdmin,
    setIsAdmin,
    name,
    room,
    setName,
    setRoom,
    // users,
    // setUsers,
    roomId,
    setRoomId,
    messages,
    setMessages,
    isTyping,
    setIsTyping,
    comments,
    setComments,
    data,
    setData,
    user,
    setUser,
    isLoading,
    setIsLoading,
    displayNameUser,
    setDisplayNameUser,
    isShowDream,
    setIsShowDream,
    expoTokenAdmin,
    setExpoTokenAdmin,
    categories,
    setCategories,
    amountOfItemsInCart,
    newList,
    setNewList,
    handleAddProduct,
    cartItmes,
    setCartItems,
    handleRemoveProduct,
    totalPrice,
    numberInCart,
    token,
    setToken,
    isActive,
    setIsActive,
    values,
    setValues,
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
